var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("my-asidebar", { attrs: { "active-tab": "reports" } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "dashboard-area p-3" },
        [
          _c("top-bar"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-12" }, [
              _vm.sailBookingReportData != null
                ? _c(
                    "div",
                    { staticClass: "form-box" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "v-app",
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.sailBookingReportData,
                              "items-per-page": 100,
                              search: _vm.search,
                              "custom-filter": _vm.filter,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "top",
                                  fn: function () {
                                    return [
                                      _c("v-text-field", {
                                        staticClass: "mx-4",
                                        attrs: { label: "Arama" },
                                        model: {
                                          value: _vm.search,
                                          callback: function ($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "item.bookingNumber",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c("tr", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item.bookingNumber) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.totalEndorsement",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c("tr", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("toCurrency")(
                                                item.totalEndorsement
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.averageAge",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c("tr", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item.averageAge.toFixed(2)) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.sailDate",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c("tr", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("ddMMyyyy")(item.sailDate)
                                            ) +
                                            "\n                    "
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              314661852
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-12 ml-2" }, [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("base-edit-input", {
                  attrs: { rules: "required", type: "text", label: "Email" },
                  model: {
                    value: _vm.email,
                    callback: function ($$v) {
                      _vm.email = $$v
                    },
                    expression: "email",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "input-box",
                    staticStyle: { "margin-left": "10px" },
                  },
                  [
                    _c("label", [_vm._v("-")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "theme-btn",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.onSendEmail()
                            },
                          },
                        },
                        [_vm._v("Gönder")]
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-title-wrap" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [_c("h3", { staticClass: "title" }, [_vm._v("Sail Booking Report")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }